import * as React from 'react';
import Navbar from 'components/Navbar';

import { TitleWrapper } from './styles';

interface Props {
  title: string;
  titleClassName?: string;
}

const InformationPage: React.FC<React.PropsWithChildren<Props>> = ({ children, title, titleClassName = 'max-w-sm' }) => {
  return (
    <div>
      <TitleWrapper className="safearea-pad-top">
        <Navbar isStatic isTransparent hideBanner />
        <div className={`styled-font mx-auto pb-20 pt-16 text-center text-5xl font-bold ${titleClassName}`}>
          {title}
        </div>
      </TitleWrapper>
      <div>{children}</div>
    </div>
  );
};

export default InformationPage;
